<template>
    <section class="app-container">
      <el-button type="primary" @click="handleAdd" style="margin-bottom:15px">新增商品</el-button>
  
      <el-table :data="list" v-loading="listLoading" style="width: 100%">
        <el-table-column prop="Name" label="商品名称" width="200"/>
        <el-table-column prop="Description" label="描述"/>
        <el-table-column prop="Price" label="价格" width="120"/>
        <el-table-column prop="Type" label="类型" width="120"/>
        <el-table-column label="权限等级" width="120">
          <template slot-scope="scope">
            {{ formatPermissionLevel(scope.row.RequiredPermissionLevel) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.Id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <el-pagination
        layout="total, prev, pager, next"
        :current-page="page"
        :page-size="20"
        :total="total"
        @current-change="handlePageChange"
      />
  
      <!-- 编辑/新增对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="formVisible" :close-on-click-modal="false">
        <el-form :model="formData" :rules="formRules" ref="productForm">
          <el-form-item label="商品名称" prop="Name">
            <el-input v-model="formData.Name"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="Description">
            <el-input type="textarea" v-model="formData.Description"></el-input>
          </el-form-item>
          <el-form-item label="价格" prop="Price">
            <el-input-number v-model="formData.Price" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="商品类型" prop="Type">
            <el-select v-model="formData.Type">
              <el-option label="消耗品" value="Consumable"></el-option>
              <el-option label="永久" value="Permanent"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用限制" prop="UsageLimit">
            <el-input-number v-model="formData.UsageLimit" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="权限等级" prop="RequiredPermissionLevel">
            <el-select v-model="formData.RequiredPermissionLevel" style="width: 100%">
              <el-option label="无限制" :value="0"></el-option>
              <el-option label="总督权限" :value="1"></el-option>
              <el-option label="提督权限" :value="2"></el-option>
              <el-option label="舰长权限" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用游戏类型" prop="ApplicableGameTypes">
            <el-select 
              v-model="selectedGameTypes" 
              multiple
              @change="handleGameTypeChange">
              <el-option
                v-for="item in gameTypes"
                :key="item.Value"
                :label="item.Name"
                :value="item.Value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用兵种">
            <el-select 
              v-model="selectedArmies" 
              multiple
              filterable>
              <el-option
                v-for="item in armyOptions"
                :key="item.Code"
                :label="item.Name"
                :value="item.Code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="游戏内名称" prop="NameInGame">
            <el-input v-model="formData.NameInGame"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </template>
  
  <script>
  import { 
    getProducts,
    addProduct,
    updateProduct,
    deleteProduct,
    getGameTypes,
    getArmyOptions
  } from '@/api/api'
  
  export default {
    data() {
      return {
        list: [],
        total: 0,
        page: 1,
        listLoading: false,
        formVisible: false,
        isEditMode: false,
        gameTypes: [],
        armyOptions: [],
        selectedGameTypes: [],
        selectedArmies: [],
        formData: {
          Id: '',
          Name: '',
          Description: '',
          Price: 0,
          Type: 'Consumable',
          UsageLimit: 0,
          RequiredPermissionLevel: 0,
          ApplicableGameTypes: '',
          NameInGame: '',
          ArmyNames: ''
        },
        formRules: {
          Name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
          Price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
          UsageLimit: [{ required: true, message: '请输入使用限制', trigger: 'blur' }]
        }
      }
    },
    computed: {
      dialogTitle() {
        return this.isEditMode ? '编辑商品' : '新增商品'
      }
    },
    mounted() {
      this.fetchOptions()
      this.handleQuery()
    },
    methods: {
      formatPermissionLevel(level) {
        const texts = ['无限制', '总督权限', '提督权限', '舰长权限']
        return texts[level] || '未知权限'
      },
      async fetchOptions() {
        // 获取游戏类型
        const gameRes = await getGameTypes()
        this.gameTypes = gameRes.data.response

        this.gameTypeMap = new Map(
          this.gameTypes.map(item => [item.Name, item.Value])
        )
        
        // 获取兵种选项
        const armyRes = await getArmyOptions({ page: 1, pageSize: 100 })
        this.armyOptions = armyRes.data.response.data
      },
      handleQuery() {
        this.listLoading = true
        getProducts({
          page: this.page,
          pageSize: 20
        }).then(res => {
          const response = res.data.response
          this.list = response.data
          this.total = response.dataCount
          this.listLoading = false
        })
      },
      handleAdd() {
        this.isEditMode = false
        this.formData = this.$options.data().formData
        this.selectedGameTypes = []
        this.selectedArmies = []
        this.formVisible = true
      },
      handleEdit(row) {
        this.isEditMode = true
        this.formData = { ...row }
        this.selectedGameTypes = row.ApplicableGameTypes.split(',')
        console.log("this.selectedGameTypes", this.selectedGameTypes)
        this.selectedArmies = row.ArmyNames.split(',')
        this.formVisible = true
      },
      handleGameTypeChange(values) {
        console.log("gameTypeMap", this.gameTypeMap)
        // 转换所有值为数字
        const numericValues = values.map(v => {
          if (typeof v === 'string') {
            const trimmed = v.trim()  // 新增去空格处理
            return this.gameTypeMap.get(trimmed) || 0
          }
          return Number(v)
        })

        // 计算位掩码
        console.log("values",values)
        console.log("numericValues",numericValues)
        this.formData.ApplicableGameTypes = numericValues.reduce((a, b) => a | b, 0)
        console.log("this.formData", this.formData)
      },
      submitForm() {
        this.$refs.productForm.validate(valid => {
          if (valid) {
            // 处理兵种编码
            this.formData.ArmyNames = this.selectedArmies.join(',')
            
            const api = this.isEditMode ? updateProduct : addProduct
            api(this.formData).then(res => {
              if (res.data.success) {
                this.$message.success(this.isEditMode ? '更新成功' : '添加成功')
                this.formVisible = false
                this.handleQuery()
              }
            })
          }
        })
      },
      handleDelete(id) {
        this.$confirm('确认删除该商品吗?', '提示', {
          type: 'warning'
        }).then(() => {
          deleteProduct(id).then(res => {
            if (res.data.success) {
              this.$message.success('删除成功')
              this.handleQuery()
            }
          })
        })
      },
      handlePageChange(val) {
        this.page = val
        this.handleQuery()
      }
    }
  }
  </script>
